/* ==========================================================================
   Rosales Gallery — comportamiento del tema
   Todo es mejora progresiva: sin JavaScript el menú se ve abierto, la
   galería muestra la primera foto y «Comprar ahora» va directo al pago.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Menú móvil
     ------------------------------------------------------------------------ */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var toggle = header.querySelector('[data-header-toggle]');
    if (!toggle) return;

    function setOpen(open) {
      header.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function () {
      setOpen(!header.classList.contains('is-open'));
    });

    header.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    // Un ancla de la misma página (/#pared) cierra el menú
    header.querySelectorAll('.nav a').forEach(function (link) {
      link.addEventListener('click', function () { setOpen(false); });
    });
  }

  /* ------------------------------------------------------------------------
     Galería de la ficha
     ------------------------------------------------------------------------ */
  function initGallery(root) {
    var gallery = root.querySelector('[data-gallery]');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('[data-slide]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-thumb');
        slides.forEach(function (slide) {
          slide.hidden = slide.getAttribute('data-slide') !== index;
        });
        thumbs.forEach(function (other) {
          if (other === thumb) other.setAttribute('aria-current', 'true');
          else other.removeAttribute('aria-current');
        });
      });
    });
  }

  /* ------------------------------------------------------------------------
     Desplegables: uno abierto a la vez (respaldo para navegadores sin
     el atributo name en <details>)
     ------------------------------------------------------------------------ */
  function initAccordion(root) {
    var items = root.querySelectorAll('details.accordion');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  /* ------------------------------------------------------------------------
     Variantes: actualiza el precio visible
     ------------------------------------------------------------------------ */
  function initVariants(root) {
    var select = root.querySelector('[data-variant-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var price = option && option.getAttribute('data-price');
      var target = root.querySelector('.product__price strong');
      if (price && target) target.textContent = price;
      var summary = root.querySelector('[data-summary-price]');
      if (price && summary) summary.textContent = price;
    });
  }

  /* ------------------------------------------------------------------------
     Compra: resumen en modal → carrito → pago
     ------------------------------------------------------------------------ */
  function initPurchase(root) {
    var form = root.querySelector('[data-product-form]');
    var dialog = root.querySelector('[data-summary]');
    var error = root.querySelector('[data-product-error]');
    if (!form) return;

    function selectedPayment() {
      var checked = root.querySelector('[data-payment]:checked');
      return checked ? checked.getAttribute('data-payment') : 'single';
    }

    function syncSummary() {
      if (!dialog) return;
      var mode = selectedPayment();
      var label = dialog.querySelector('[data-summary-label]');
      var amount = dialog.querySelector('[data-summary-amount]');
      if (label) label.textContent = label.getAttribute('data-' + mode);
      if (amount) amount.textContent = amount.getAttribute('data-' + mode);
    }

    function openDialog() {
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      syncSummary();
      dialog.showModal();
      document.body.classList.add('has-modal');
      return true;
    }

    function closeDialog() {
      if (dialog && dialog.open) dialog.close();
    }

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    function checkout() {
      if (error) error.hidden = true;
      if (dialog) dialog.classList.add('is-loading');

      var data = new FormData(form);
      data.delete('return_to');

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: data
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.description || body.message || '');
            return body;
          });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          if (dialog) dialog.classList.remove('is-loading');
          closeDialog();
          showError(err.message || window.themeStrings.cartError);
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var trigger = event.submitter;
      var wantsSummary = trigger && trigger.hasAttribute('data-open-summary');
      if (wantsSummary && openDialog()) return;
      checkout();
    });

    root.querySelectorAll('[data-payment]').forEach(function (input) {
      input.addEventListener('change', syncSummary);
    });

    if (!dialog) return;

    dialog.querySelector('[data-summary-confirm]').addEventListener('click', checkout);
    dialog.querySelector('[data-summary-close]').addEventListener('click', closeDialog);

    // Cierra al pulsar fuera de la tarjeta, como en el diseño
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', function () {
      document.body.classList.remove('has-modal');
      dialog.classList.remove('is-loading');
    });
  }

  function initProducts() {
    document.querySelectorAll('[data-product]').forEach(function (root) {
      initGallery(root);
      initAccordion(root);
      initVariants(root);
      initPurchase(root);
    });
  }

  function init() {
    initHeader();
    initProducts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Personalizador: reengancha al recargar una sección
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-header]')) initHeader();
    if (event.target.querySelector('[data-product]')) initProducts();
  });
})();
